import axios from 'axios';
import Constants from '../constants';
import { IEmail } from '../models/IEmail';

export function getEmailQuery() {
	const params = Constants.API_EMAIL_URL;
	return params;
}

export async function sendEmail(email: IEmail): Promise<string> {
	const res = await axios.post(getEmailQuery(), email);
	return res.data;
}
